export { default } from "./Loading-component";
